"use client"

import { Box, NoSsr } from '@mui/material';
import { styled } from '@mui/material/styles';

import { cssStyles } from '../../utils';

import type { GradientDirection } from '../../utils';
import type { BoxProps } from '@mui/material';
import type { FC } from 'react';

export interface BackgroundOverlayProps extends BoxProps {
  direction?: GradientDirection;
  startColor?: string;
  endColor?: string;
}

const Overlay = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'direction' && prop !== 'startColor' && prop !== 'endColor',
})<BackgroundOverlayProps>(({ direction, startColor, endColor, theme }) => ({
  top: 0,
  left: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  position: 'absolute',
  ...cssStyles(theme).bgGradient({
    direction,
    startColor,
    endColor,
  }),
}));

// ----------------------------------------------------------------------

export const BgOverlay: FC<BackgroundOverlayProps> = ({
  direction,
  startColor,
  endColor,
  ...other
}) => (
  <NoSsr>
    <Overlay
      direction={direction}
      startColor={startColor}
      endColor={endColor}
      {...other}
    />
  </NoSsr>
);
